<template>
  <div class="mt-3 text-left bg-white pb-3 mb-5" id="comment_display">
    <item-title sub-title="评论"/>
    <!--酒店评论总体概况-->
    <div class="d-flex mt-2 pl-2 pr-2 justify-content-between" v-if="DisplayCommentInfo.commentNum>0">
      <div class="d-flex align-items-center">
        <div class="rate-round"
              :style="{backgroundImage:'url(/images/public/commentRate_'+ Math.floor(DisplayCommentInfo.equallyNum) +'.png)'}">
          <div class="d-flex align-items-end"><span class="text-warning mr-1">{{DisplayCommentInfo.equallyNum}}</span>分
          </div>
        </div>
        <div class="text-muted ml-1">已有 <span class="text-warning">{{DisplayCommentInfo.peopleNum || DisplayCommentInfo.commentNum}}</span> 人点评</div>
      </div>
      <div class="d-flex flex-column justify-content-center">
        <div class="text-muted grade-progress">环境设施：<label><span></span></label><span class="text-warning ml-3 mr-1">{{DisplayCommentInfo.hotel_facilities}}</span>分
        </div>
        <div class="text-muted grade-progress mt-3">服务态度：<label><span></span></label><span
          class="text-warning ml-3 mr-1">{{DisplayCommentInfo.hotel_environment}}</span>分
        </div>
      </div>
    </div>
    <!--评论数据tab选项卡-->
    <div class="border-bottom border-top mt-2 mb-2 pl-2 pr-2">
      <ul class="d-center-between text-center text-muted list-unstyled h6 line-height w-60">
        <li :class="[{'selected-item':currentType==''},'item-hover']">
          <span class="cursor-pointer" @click="getCommentRateList('')">全部（{{DisplayCommentInfo.commentNum}}）</span></li>
        <li :class="[{'selected-item':currentType=='1'},'item-hover']">
          <span class="cursor-pointer" @click="getCommentRateList('1')">晒图（{{DisplayCommentInfo.picNum}}）</span></li>
        <li :class="[{'selected-item':currentType=='2'},'item-hover']">
          <span class="cursor-pointer" @click="getCommentRateList('2')">好评（{{DisplayCommentInfo.goodNum}}）</span></li>
        <li :class="[{'selected-item':currentType=='3'},'item-hover']">
          <span class="cursor-pointer" @click="getCommentRateList('3')">中评（{{DisplayCommentInfo.reviewNum}}）</span></li>
        <li :class="[{'selected-item':currentType=='4'},'item-hover']">
          <span class="cursor-pointer" @click="getCommentRateList('4')">差评（{{DisplayCommentInfo.badNum}}）</span></li>
      </ul>
    </div>
    <!--暂无评论-->
    <div v-if="CommentsListByRate.length <= 0" class="d-center flex-column">
      <img src="/images/public/noComment.png" alt="">
      <h4 class="font-weight-normal h6">暂无评论</h4>
    </div>
   <!--有评论信息-->
    <div class="pl-2 pr-2" v-else>
      <!--评论列表数组-->
      <div class="d-flex align-items-start border-bottom mb-3 pb-3 pr-2"
           v-for="(commentItem,index) in CommentsListByRate"
           :key="index">
        <!--发布人头像名称-->
        <div class="text-center pt-2 h6" style="width: 160px;">
          <img :src="commentItem.avatar?ImgPreUrl+commentItem.avatar : '/images/public/defaultImg.png'" alt=""
               width="50"
               height="50" style="border-radius: 50%">
          <div class="mt-2">
            <label>{{commentItem.comment_name.slice(0,1)}}**</label>
            <span v-if="commentItem.comment_store_type==2" class="text-blue">（采购商）</span>
            <span v-if="commentItem.comment_store_type==4" class="text-blue">（导游）</span>
          </div>
        </div>
        <!--评论内容详情-->
        <div class="ml-3 w-100 pb-3">
          <!--评分-->
          <div class="d-center-between pt-1">
            <div class="d-flex align-items-center">
              <el-rate v-model="commentItem.hotel_equally" disabled show-score text-color="#ff9900"></el-rate>
              <span class="ml-1 h6">分</span></div>
            <div class="text-muted h6">{{commentItem.comment_time | formatTimestamp(1)}}</div>
          </div>
          <!--评论内容-->
          <div class="mt-2 h6">{{commentItem.comment}}</div>
          <!--评论图片-->
          <div class="mt-3" v-if="commentItem.comment_pic">
            <img class="mr-2 cursor-pointer" :src="ImgPreUrl+commengImgItem" alt=""
                 @click="imgPreview(index,commentItem)"
                 v-for="(commengImgItem,index) in commentItem.comment_pic.split(',')" width="100" height="100"
                 :key="index">
          </div>
          <!--酒店回复-->
          <div class="mt-3" v-if="commentItem.reply!=''">
            <div class="d-flex justify-content-between align-items-center h6">
              <h5 class="font-weight-bold mb-1">{{typeInfo.type == 8 ? '品牌馆' : '酒店'}}回复：</h5>
              <span class="h6">{{commentItem.reply_time | formatTimestamp(1)}}</span>
            </div>
            <div class="text-left p-2 h6" style="text-indent: 2em;background: #eee;">{{commentItem.reply}}</div>
          </div>
        </div>

      </div>
      <!--分页器-->
      <el-pagination layout="prev, pager, next" class="d-center mt-4" v-if="CommentTotalNum > 10"
                     :total=Number(CommentTotalNum) :current-page=current
                     @current-change='pageChange'/>
    </div>
  </div>
</template>

<script>
  import {mapState, mapActions} from 'vuex'
  import ItemTitle from './ItemTitle'

  export default {
    name: 'UserComments',
    components: {ItemTitle},
    data() {
      return {
        currentType: '',             //当前的评论类型
        current: 1,                 // 当前的页数
      }
    },
    computed: {
      ...mapState(['DisplayCommentInfo', 'CommentsListByRate', 'CommentTotalNum']),
      typeInfo() {
        let url = this.$route.fullPath.split('/')[2];
        if (url === 'index_homestay') return {en: 'homestay', cn: '民宿', type: '5'};
        if (url === 'index_hotel') return {en: 'hotel', cn: '酒店', type: '3'};
        if (url === 'index_scenic') return {en: 'scenic', cn: '景区', type: '6'};
        if (url === 'index_brand') return {en: 'brand', cn: '品牌馆', type: '8'};
        return '';
      },
    },
    created() {
      setTimeout(this.getCommentRateList(this.currentType),10)
    },
    mounted() {
      this.changWidth();
    },
    methods: {
      ...mapActions(['CommentsByRate']),
      getCommentRateList(commentType) {
        this.currentType = commentType;
        this.CommentsByRate({
          id: this.$route.params.id || this.brandId,
          page: this.current,
          num: 10,
          statue: commentType,
          storeType: this.typeInfo.type
        })
      },
      /*图片预览*/
      imgPreview(index, item) {
        this._CarouselView({
          currentImg: index,
          picArray: item.comment_pic.split(',')
        })
      },
      //改变页码
      pageChange(currentPage) {
        this.current = currentPage;
        this.getCommentRateList();
      },
      changWidth() {
        let facilitiesWidth = (this.DisplayCommentInfo.hotel_facilities / 5) * 100;
        let attitudeWidth = (this.DisplayCommentInfo.hotel_environment / 5) * 100;
        $('.grade-progress label span').eq(0).width(facilitiesWidth + '%');
        $('.grade-progress label span').eq(1).width(attitudeWidth + '%');
      }
    }
  }
</script>

<style lang="scss" scoped>
  .rate-round {
    width: 100px;
    height: 100px;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      font-size: 30px;
      line-height: 30px;
    }
  }

  .grade-progress {
    display: flex;
    align-items: center;
    label {
      width: 191px;
      height: 14px;
      display: flex;
      align-items: center;
      background: rgba(253, 185, 0, .4);
      border-radius: 8px;
      margin-bottom: 0;
      padding: 0 2px;
      span {
        display: inline-block;
        width: 159px;
        height: 10px;
        background: rgba(253, 185, 0, .6);
        border-radius: 6px;
      }
    }
  }

  .selected-item {
    font-weight: bolder;
    font-size: 16px;
    border-bottom:2px solid #999;
  }

  .line-height{
    line-height: 40px;
    padding: 0 10px;
  }

  .item-hover:hover{
    font-weight: bolder;
    border-bottom: 1px solid #999;
  }

</style>
